export default __webpack_public_path__ + "static/media/SEAT.11165915.png";